import React from "react";
import DataGrid, {
  Column,
  Selection,
  FilterRow,
  Paging,
  Pager,
  Toolbar,
  Item,
} from "devextreme-react/data-grid";
import moment from "moment";
import { formatMessage } from "devextreme/localization";
import { useScreenSize } from "../../../utils/media-query";

import ToolbarBefore from "../../../components/toolbar-before/ToolbarBefore";
import ToolbarAfter from "./ToolbarAfter";
import { useAuth } from "../../../contexts/auth";
import { axios } from "../../../common";

export default function TransactionAdjustmentDataTableList({
  dataGrid,
  middleware,
}) {
  const { user } = useAuth();
  const [fromDate, setFromDate] = React.useState();
  const [toDate, setToDate] = React.useState();
  const { isXSmall, isSmall } = useScreenSize();
  const [transactionData, setTransactionData] = React.useState([]);

  const handleChangeSelectBox = async () => {
    const FromDate = moment(fromDate).format("YYYY-MM-DD");
    const ToDate = moment(toDate).format("YYYY-MM-DD");

    const payload = {
      FromDate: FromDate,
      ToDate: ToDate,
      EmployeeOid: user?.EmployeeOid,
    };
    const { data } = await axios.get("TransactionAdjustmentData", {
      params: {
        $filter:
          "EmployeeCode eq " +
          `'${user?.EmployeeCode}'` +
          "" +
          " and WorkingDay gt " +
          payload.FromDate +
          "" +
          " and WorkingDay lt " +
          payload.ToDate +
          "",
      },
    });
    if (!data) {
      return;
    }
    setTransactionData(data.value);
  };
  return (
    <div>
      <DataGrid
        id="gridContainer"
        height={isXSmall || isSmall ? "auto" : document.documentElement.offsetHeight - 189}
        showBorders={true}
        showRowLines={true}
        hoverStateEnabled={true}
        rowAlternationEnabled={true}
        columnAutoWidth={true}
        columnResizingMode="widget"
        alignment="center"
        allowColumnReordering={true}
        allowColumnResizing={true}
        columnHidingEnabled={true}
        ref={(e) => {
          dataGrid.current = e;
        }}
        dataSource={transactionData}
      >
        <Selection
          mode="multiple"
          selectAllMode="page"
          showCheckBoxesMode="always"
        />
        <FilterRow visible={true} />
        <Paging defaultPageSize={10} />
        <Pager
          showPageSizeSelector={true}
          allowedPageSizes={[10, 20, 50, 100]}
          showInfo={true}
          visible={true}
        />
        <Column
          caption={formatMessage("EmployeeCode")}
          dataField="EmployeeCode"
          dataType="string"
          hidingPriority={isXSmall || isSmall ? 1 : false}
        />
        <Column
          caption={formatMessage("EmployeeName")}
          dataField="FullName"
          dataType="string"
          hidingPriority={isXSmall || isSmall ? 1 : false}
        />
        <Column
          caption={formatMessage("PeriodName")}
          dataField="Period.PeriodName"
          hidingPriority={isXSmall || isSmall ? 1 : false}
        />
        <Column
          caption={formatMessage("DepartmentName")}
          dataField="DepartmentName"
          dataType="string"
          hidingPriority={isXSmall ? 1 : false}
        />
        <Column
          caption={formatMessage("ShiftName")}
          dataField="ShiftName"
          hidingPriority={isXSmall ? 1 : false}
        />
        <Column
          caption={formatMessage("ShiftTimeIn")}
          dataField="ShiftTimeIn"
          hidingPriority={isXSmall ? 1 : false}
        />
        <Column
          caption={formatMessage("ShiftTimeOut")}
          dataField="ShiftTimeOut"
          hidingPriority={isXSmall ? 1 : false}
        />
        <Column
          caption={formatMessage("TimeIn")}
          dataField="TimeIn"
          hidingPriority={isXSmall ? 1 : false}
        />
        <Column
          caption={formatMessage("TimeOut")}
          dataField="TimeOut"
          hidingPriority={isXSmall ? 1 : false}
        />
        <Column
          caption={formatMessage("AdjustmentTimeIn")}
          dataField="AdjustmentTimeIn"
          dataType="string"
        />
        <Column
          caption={formatMessage("AdjustmentTimeOut")}
          dataField="AdjustmentTimeOut"
          hidingPriority={isXSmall || isSmall ? 4 : false}
        />
        <Column
          caption={formatMessage("AdjustmentTimeInIsNextDay")}
          dataField="AdjTimeInIsNextDay"
          hidingPriority={isXSmall || isSmall ? 3 : false}
        />
        <Column
          caption={formatMessage("AdjustmentTimeOutIsNextDay")}
          dataField="AdjTimeOutIsNextDay"
          hidingPriority={isXSmall || isSmall ? 3 : false}
        />
        <Column
          caption={formatMessage("Reason")}
          dataField="Reason"
          hidingPriority={isXSmall ? 1 : false}
        />
        <Column
          caption={formatMessage("Explain")}
          dataField="Explain"
          hidingPriority={isXSmall || isSmall ? 3 : false}
        />
        <Column
          caption={formatMessage("ApprovalStatus")}
          dataField="ApprovalStatus"
          hidingPriority={isXSmall || isSmall ? 3 : false}
        />
        <Column
          caption={formatMessage("ApprovalComments")}
          dataField="ApprovalComments"
          hidingPriority={isXSmall ? 1 : false}
        />
        <Toolbar className="datagrid-toolbar-actions">
          <Item
            location="before"
            locateInMenu={isXSmall || isSmall ? "always" : "auto"}
            cssClass={"datagrid-toolbar-actions-dropdown"}
          >
            <ToolbarBefore
              middleware={middleware}
              setFromDate={setFromDate}
              setToDate={setToDate}
              dataGrid={dataGrid}
              handleChangeSelectBox={handleChangeSelectBox}
            />
          </Item>
          <Item
            location="after"
            locateInMenu={isXSmall || isSmall ? "always" : "auto"}
            cssClass={"datagrid-toolbar-actions-dropdown"}
          >
            <ToolbarAfter middleware={middleware} dataGrid={dataGrid} />
          </Item>
        </Toolbar>
      </DataGrid>
    </div>
  );
}
